import React, { FC, useState } from "react";
import MaskedInput from "react-text-mask";

type MaskType = "auto" | "cpf" | "cnpj"

export interface CPFCNPJMaskProperties {
    inputRef: (ref: HTMLInputElement | null) => void;
    guide?: boolean;
    maskType?: MaskType;
}

const CPFCNPJMask: FC<CPFCNPJMaskProperties> = (props: CPFCNPJMaskProperties) => {
    const { inputRef, ...other } = props;

    const [currentMask, setCurrentMask] = useState<"cpf" | "cnpj">(other?.maskType && other?.maskType !== "auto" ? other.maskType : "cpf")

    const masks = {
        cpf: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, "-", /\d/, /\d/],
        cnpj: [
            /[A-Za-z0-9]/, /[A-Za-z0-9]/, '.', 
            /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '.', 
            /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '/', 
            /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '-', 
            /\d/, /\d/
        ]
    }

    const type: MaskType = other?.maskType || "auto"


    return (
        <MaskedInput
            {...other}
            ref={(ref: any) => {
                const input = ref ? ref.inputElement : null;

                if (typeof inputRef === 'function') {
                    inputRef(input);
                }

                if (inputRef && typeof inputRef === 'object') {
                    (inputRef as React.MutableRefObject<HTMLInputElement | null>).current = input;
                }
            }}
            mask={masks[currentMask]}
            placeholderChar={'\u2000'}
            showMask
            guide={other?.guide || false}
            onKeyDown={(event: any) => {
                if (type === "auto" && event.target.value.replace(/[^A-Za-z0-9]/g, "").length >= 11) {
                    setCurrentMask("cnpj")
                }
            }}
            onKeyUp={(event: any) => {
                if (type === "auto" && event.target.value.replace(/[^A-Za-z0-9]/g, "").length <= 11) {
                    setCurrentMask("cpf")
                }
            }}
        />
    );
}

export { CPFCNPJMask }